module.exports = __webpack_public_path__ + "img/hmd.fe514431.svg";